import { ProviderCapabilitiesSchema, type GenerationKind, type GenerationRequest } from '../domain/schemas';
import { GENERATION_KIND_LABELS, ProviderError, type GenerationProvider, type ProviderAvailability } from './types';

/**
 * Placeholder for a capability that needs an external provider which is not configured.
 * It never makes network requests and never fabricates output.
 */
export class UnconfiguredProvider implements GenerationProvider {
  readonly capabilities;
  private readonly reason: string;

  constructor(kind: GenerationKind) {
    this.capabilities = ProviderCapabilitiesSchema.parse({
      providerId: `unconfigured-${kind}`,
      displayName: GENERATION_KIND_LABELS[kind],
      kinds: [kind],
      local: false,
      requiresConfiguration: true,
      maxPromptLength: 2000,
      outputFormats: [],
      supportsCancellation: false,
    });
    this.reason = `No ${GENERATION_KIND_LABELS[kind].toLowerCase()} provider is configured. External generation is not part of Phase 0.`;
  }

  availability(): ProviderAvailability {
    return { state: 'unconfigured', reason: this.reason };
  }

  async generate(_request: GenerationRequest): Promise<never> {
    throw new ProviderError('unavailable', this.reason);
  }
}
